import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { choirpal_blue_100 } from '../../Theme/colors';

const fontSizes = {
  small: 20,
  medium: 26,
  large: 38,
};

const StyledH3 = styled.h3`
  font-family: 'Platform Web';
  font-weight: 400;
  color: ${choirpal_blue_100};
  font-size: ${props => props.fontSize}px;
  margin-top: 8px;
  margin-bottom: 8px;
`;

export default function H3({ children, className, size = 'small' }) {
  const fontSize = fontSizes[size];
  return (
    <StyledH3 fontSize={fontSize} className={className}>
      {children}
    </StyledH3>
  );
}

H3.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.array,
  size: PropTypes.string,
};
